import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let GetSocialLinksThunk = createAsyncThunk(
	"socialLinks/GetSocialLinks",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`/api/social_links`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
